// ** Third Party Imports
import { Heading, Typography } from '@/shared/ui'
import styled from 'styled-components'

export const OptionsWrapper = styled.div`
	display: flex;
	width: 100%;
	column-gap: 1.5rem;

	@media (max-width: 1024px) {
		flex-direction: column;
		row-gap: 1.5rem;
	}
`

export const CardWrapper = styled.div`
	box-shadow: 0px 1px 3px 0px #84889826;
	width: 100%;
	background: #abd4d233;
	border-radius: 8px;
	padding: 1rem;
	display: flex;
	flex-direction: column;
	row-gap: 1rem;

	&.enterprise {
		border: 1px solid #abd4d233;
		box-shadow: 0px 1px 3px 0px #84889826;
		background: white;
	}

	& button {
		margin-top: 1.5rem;
	}
`
export const HeadingRow = styled.div`
	display: flex;
	align-items: center;
	column-gap: 1rem;

	& div {
		height: 2rem;
		& p {
			font-size: 0.8rem;
		}
	}
`

export const StyledHeading = styled(Heading)``

export const StyledTypography = styled(Typography)``

export const PricingRow = styled.div`
	display: flex;
	gap: 1rem;
	margin-bottom: 1rem;
`

export const StyledSpan = styled.span`
	display: flex;
	gap: 0.5rem;
	align-items: baseline;
`

export const CheckRow = styled.span`
	display: flex;
	align-items: center;
	gap: 0.5rem;
`